export function itemOf<T>(items: T[], item: unknown): item is T {
	return items.includes(item as T);
}
